import { generateRandomId } from 'core/utils';
import { Months } from '../constants';
import {
  Contributor,
  ContributorTypes,
  IPublicationInfo,
  CitationSourceEnum,
  CitationData,
} from '../types';

export interface Oclc {
  oclcNumber: string;
  title: string;
  creator: string;
  date: string;
  language: string;
  generalFormat: string;
  specificFormat: string;
  publisher: string;
  publicationPlace: string;
  isbns: string[];
  mergedOclcNumbers: string[];
}

export enum CitationContributorTypes {
  AUTHOR = 'author',
  EDITOR = 'editor',
  TRANSLATOR = 'translator',
  ILLUSTRATOR = 'illustrator',
  INDEXBY = 'indexBy',
}
// Contributor
export interface CitationContributor {
  firstName?: string;
  // middleName?: string;
  initials?: string;
  lastName?: string;
  role?: 'author' | 'editor' | 'compiler' | 'translator';
}
// Citation object required for frontend
export interface CitationObject {
  contributors?: CitationContributor[];
  dateModified?: string;
  datePublished?: string;
  doi?: string;
  edition?: string;
  id: string;
  isbn?: string;
  publicationPlace?: string;
  publisher?: string;
  series?: string;
  subTitle?: string;
  title: string;
  url?: string;
}

enum ContributorTypeMaping {
  author = 'authors',
  editor = 'editors',
  compiler = 'compilers',
  translator = 'translators',
}
// Api response for frontend from bib search api
export interface ApiResponseForBiblioSearch {
  numberOfRecords: number;
  records: CitationObject[];
}

export const bibToCitation = (
  value: CitationObject | null,
  searchType: CitationSourceEnum,
  url?: string
): CitationData => {
  if (!value) {
    return {} as CitationData;
  }

  const contributors: Contributor[] = [];
  const publicationInfo: IPublicationInfo = { citedPages: {}, publishDate: {}, accessDate: {} };

  publicationInfo.url = url;
  publicationInfo.containerTitle = value.subTitle;
  publicationInfo.edition = value.edition;
  publicationInfo.collectionTitle = value.series;
  publicationInfo.doi = value.doi;
  publicationInfo.isbn = value.isbn;

  if (value.title) {
    publicationInfo.title = value.title.trim();
  }
  if (value.datePublished) {
    const dateArray = value.datePublished.split('-');
    publicationInfo.publishDate = {
      year: parseInt(dateArray[0], 10),
      month: Months[parseInt(dateArray[1], 10) - 1] || '',
      day: parseInt(dateArray[2], 10),
    };
  }
  if (value.publisher) {
    publicationInfo.publisher = value.publisher;
  }
  if (value.publicationPlace) {
    const place = value.publicationPlace.split(',');
    publicationInfo.city = place[0]?.trim();
    publicationInfo.state = place[1]?.trim() || '';
  }
  if (value.contributors) {
    value.contributors.forEach((contributor, i) => {
      contributors.push({
        key: `${generateRandomId()}-${i}`,
        contributorType: ContributorTypeMaping[
          contributor.role &&
          Object.values(ContributorTypes).includes(contributor.role as ContributorTypes)
            ? contributor.role
            : 'author'
        ] as unknown as ContributorTypes,
        // suffix: '',
        firstName: contributor.firstName || '',
        // middleName: contributor.middleName || '',
        lastName: contributor.lastName || '',
        initials: contributor.initials,
      });
    });
    // contributors = [value.creator];
  }
  if (searchType === CitationSourceEnum.WEBSITE) {
    const toDay = new Date();
    if (value.subTitle && value.title) {
      publicationInfo.title = value.subTitle;
      publicationInfo.containerTitle = value.title;
    } else if (value.title) {
      publicationInfo.title = value.title;
      publicationInfo.containerTitle = value.title;
    } else if (value.subTitle) {
      publicationInfo.title = value.subTitle;
    }

    publicationInfo.accessDate = {
      day: toDay.getDate(),
      month: Months[toDay.getMonth()],
      year: toDay.getFullYear(),
    };
  }
  return {
    publicationInfo,
    contributors,
    citationSource: searchType,
  } as CitationData;
};
